import { inject, numberAttribute, Pipe, PipeTransform } from '@angular/core';
import { StateService } from '../services/state.service';
import { BROWSER_LANGUAGE } from '../providers/browser-language.provider';

@Pipe({
  name: 'yesCurrency',
})
export class yesCurrencyPipe implements PipeTransform {
  private state = inject(StateService);
  private browserLanguage = inject(BROWSER_LANGUAGE);

  transform(
    value: string | number | null | undefined,
    currencyCode = this.state.getActiveCurrency(),
  ): string | undefined {
    if (value == null || !currencyCode) {
      return '';
    }

    const formatter = createNumberFormatter(this.browserLanguage, currencyCode);

    if (!formatter) {
      return '';
    }

    return formatter
      .formatToParts(numberAttribute(value))
      .reduceRight((accumulator, { type, value }) => {
        switch (type) {
          case 'currency':
            return `<span class="yes-currency">${value}</span>${accumulator}`;

          case 'fraction':
            return value === '00' ? accumulator : value + accumulator;

          case 'decimal':
            return !isNaN(parseInt(accumulator.charAt(0)))
              ? value + accumulator
              : accumulator;

          default:
            return value + accumulator;
        }
      }, '');
  }
}

function createNumberFormatter(
  language: string,
  currencyCode: string,
): Intl.NumberFormat | null {
  try {
    return new Intl.NumberFormat(language, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'code',
    });
  } catch (e) {
    if (e instanceof RangeError) {
      return null;
    } else {
      throw e;
    }
  }
}
